import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/Login";
import MainLayout from "./layout/MainLayout";
import { ProtectedRoute } from "./routes/ProtectedRoute";

import Dashboard from "./components/pages/Dashboard";
import VendorOnboarding from "./components/pages/VendorOnboarding";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="vendor-onboarding" element={<VendorOnboarding />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
